<template>
  <div class="w-full">
    <div class="flex flex-row w-full mb-2">
      <gd-button
        v-for="side in sidekeys"
        :key="side"
        :class="{ 'text-grey-700': !isSelected(side) }"
        :dark="!isSelected(side)"
        :primary="isSelected(side)"
        size="expand"
        :group-position="getGroupPosition(side)"
        @click="selectSide(side);"
      >
        <component
          :is="icon(side)"
          class=" h-4 w-4 fill-current"
          :class="{ 'text-pink': hasValue(side) }"
        ></component>
      </gd-button>
    </div>
    <gd-dropdown
      v-if="sideSelected !== null && options.length"
      v-model="sideValue"
      :options="options"
      :placeholder="placeholder"
      dark
      size="full"
      class="mb-2"
    ></gd-dropdown>
  </div>
</template>
<script>
import GdButton from './Button';
import GdDropdown from './Dropdown';
import AllSides from '../assets/all-sides.svg';
import SideBottom from '../assets/side-bottom.svg';
import SideTop from '../assets/side-top.svg';
import SideLeft from '../assets/side-left.svg';
import SideRight from '../assets/side-right.svg';

export default {
  name: 'SidesDropdownPanel',
  components: { GdButton, GdDropdown },
  props: ['values', 'options', 'placeholder'],
  data() {
    return {
      sideSelected: null,
      sides: {
        all: AllSides,
        top: SideTop,
        bottom: SideBottom,
        left: SideLeft,
        right: SideRight
      }
    };
  },
  computed: {
    sidekeys() {
      return Object.keys(this.sides);
    },
    sideValue: {
      get() {
        return this.values[this.sideSelected];
      },
      set(value) {
        this.$emit('set-style', { side: this.sideSelected, value });
      }
    }
  },
  methods: {
    hasValue(side) {
      return !this.isSelected(side) && this.values[side];
    },
    getGroupPosition(side) {
      if (side === this.sidekeys[0]) return 'left';
      if (side === this.sidekeys[this.sidekeys.length - 1]) return 'right';
      return 'middle';
    },
    icon(side) {
      return this.sides[side];
    },
    selectSide(side) {
      if (this.sideSelected === side) side = null;
      this.sideSelected = side;
      this.$emit('select-side', side);
    },
    isSelected(side) {
      return side === this.sideSelected;
    }
  }
};
</script>
